import { render, staticRenderFns } from "./DoaDataReport.vue?vue&type=template&id=58ccdc0a&scoped=true&"
import script from "./DoaDataReport.vue?vue&type=script&lang=js&"
export * from "./DoaDataReport.vue?vue&type=script&lang=js&"
import style0 from "./DoaDataReport.vue?vue&type=style&index=0&id=58ccdc0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ccdc0a",
  null
  
)

export default component.exports